import { deleteData, getData, postData, putData } from "./commonServices";
import {
  ADMIN_TASKS,
  ADMIN_TASK,
  ADMIN_ASSIGN_TASK,
  ADMIN_TASK_STATISTICS,
  USER_TASKS,
  USER_TASK_STATISTICS,
  USER_TASK_VERIFICATION,
  USER_TASK_VERIFY,
} from "../serviceUrls";

// Helper to get token from localStorage
const getToken = () => localStorage.getItem("access_token");

// Tasks API Service
export const tasksAPI = {
  // Get all tasks (with pagination) - Admin only
  getTasks: async (page = 1, perPage = 10) => {
    const token = getToken();
    return await getData(
      `${ADMIN_TASKS}?page=${page}&per_page=${perPage}`,
      token,
    );
  },

  // Get single task by ID - Admin only
  getTask: async (taskId) => {
    const token = getToken();
    return await getData(`${ADMIN_TASK}/${taskId}`, token);
  },

  // Create new task - Admin only
  createTask: async (taskData) => {
    const token = getToken();
    return await postData(`${ADMIN_TASK}/`, taskData, token);
  },

  // Update task - Admin only
  updateTask: async (taskId, taskData) => {
    const token = getToken();
    return await putData(`${ADMIN_TASK}/${taskId}`, taskData, token);
  },

  // Delete task - Admin only
  deleteTask: async (taskId) => {
    const token = getToken();
    return await deleteData(`${ADMIN_TASK}/${taskId}`, token);
  },

  // Assign task to user - Admin only
  assignTask: async (assignmentData) => {
    const token = getToken();
    return await putData(ADMIN_ASSIGN_TASK, assignmentData, token);
  },

  // Unassign task - Admin only
  unassignTask: async (taskId) => {
    const token = getToken();
    return await postData(`${ADMIN_TASK}/${taskId}/unassign`, {}, token);
  },

  // Get task statistics - Admin only
  getTaskStatistics: async () => {
    const token = getToken();
    return await getData(ADMIN_TASK_STATISTICS, token);
  },

  // User-specific endpoints (for Annotators and Reviewers)
  // Get user's assigned tasks
  getUserTasks: async (userId) => {
    const token = getToken();
    return await getData(USER_TASKS, token);
  },

  // Get user task statistics (for Annotators and Reviewers)
  getUserTaskStatistics: async () => {
    const token = getToken();
    return await getData(USER_TASK_STATISTICS, token);
  },

  // Get specific task for user
  getUserTask: async (taskId) => {
    const token = getToken();
    return await getData(`${USER_TASKS}/${taskId}`, token);
  },

  // Verify task (Reviewer only)
  verifyTask: async (taskId) => {
    const token = getToken();
    return await putData(`${USER_TASK_VERIFICATION}/${taskId}`, {}, token);
  },

  // Verify model (Reviewer only)
  verifyModel: async (modelId) => {
    const token = getToken();
    return await putData(`${USER_TASK_VERIFY}/${modelId}`, {}, token);
  },
};
